var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brew-grid"},_vm._l((_vm.brews),function(b){return _c('card',{key:b.flowmeter_id,staticClass:"brew-card",attrs:{"brew":b,"brew_sessions":_vm.brew_sessions},on:{"keg-refilled":function($event){return _vm.keg_refilled($event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }